import { initialState } from "src/slices/facility-forms-management/impersonation/impersonation-initial-state";
import { userImpersonationSlice } from "src/slices/facility-forms-management/impersonation/impersonation-slices";
import { impersonationSelector } from "src/slices/facility-forms-management/impersonation/impersonation-selector";

export { initialState };

export default userImpersonationSlice.reducer;

export { impersonationSelector };
